'use client';

import { SearchTwoTone } from '@mui/icons-material';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, IconButton, TextField, Tooltip, type SxProps } from '@mui/material';
import { flatSx, StackRow } from '@ocodelib/mui';
import { useObservable } from '@ocodelib/mui/hooks';
import { Console as ConsoleFeed } from 'console-feed';
import { useState } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { useP5BasicApp } from '../../useP5BasicApp';

interface Props {
  sx?: SxProps;
}

export function LogContainer(props: Props) {
  const { sx } = props;
  const { app } = useP5BasicApp();
  const [logSearchKeyword, setLogSearchKeyword] = useState('');
  const logs = useObservable(app?.logs$) ?? [];

  return (
    <Box
      className="LogContainer-root"
      sx={flatSx(
        {
          position: 'relative',
          bgcolor: '#fff',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
        },
        sx,
      )}
    >
      <Box
        sx={{
          height: 40,
          display: 'flex',
          alignItems: 'center',
          px: 1,
          bgcolor: '#edeff1',
          borderBottom: '1px solid #ddd',
          width: '100%',
        }}
      >
        <SearchTwoTone
          sx={{
            color: '#aaa',
            fontSize: '1.2rem',
          }}
        />
        <TextField
          margin="none"
          value={logSearchKeyword ?? ''}
          size="small"
          placeholder="Log filter"
          autoComplete="off"
          disabled={!app}
          sx={{
            width: '100vw',
            maxWidth: 300,
            ml: 1,
            '& input': {
              py: '5px',
            },
          }}
          onChange={(e) => {
            setLogSearchKeyword(e.target.value);
          }}
        />
        <StackRow alignItems="center" sx={{ ml: 'auto' }}>
          <Tooltip title={app ? 'clear log' : undefined}>
            <IconButton
              size="small"
              color="primary"
              disabled={!app}
              onClick={() => {
                app?.clearLogs();
              }}
              sx={{
                ml: 'auto',
                color: '#888',
              }}
            >
              <CleaningServicesIcon />
            </IconButton>
          </Tooltip>
          {/* 로그 접기 버튼 미사용 */}
          <Tooltip title={app ? 'hide console log' : undefined}>
            <IconButton
              size="small"
              disabled={!app}
              style={{
                marginLeft: 'auto',
              }}
              onClick={() => {
                app?.setLogVisible((p) => !p);
              }}
            >
              <ExpandMoreIcon />
            </IconButton>
          </Tooltip>
        </StackRow>
      </Box>
      <Scrollbars style={{ flex: 1 }}>
        <Box
          component={ConsoleFeed}
          variant="light"
          logs={logs ?? []}
          styles={{
            BASE_FONT_SIZE: '16px',
          }}
          searchKeywords={logSearchKeyword}
        />
      </Scrollbars>
    </Box>
  );
}
